import client from './client';

export const notificationsApi = {
  list: (params) => client.get('/notifications', { params }).then((r) => r.data),
  // A single indexed COUNT — this is what the bell polls, so it stays cheap.
  unreadCount: (params) =>
    client.get('/notifications/unread-count', { params }).then((r) => r.data),
  markRead: (id) => client.post(`/notifications/${id}/read`).then((r) => r.data),
  markAllRead: (payload) =>
    client.post('/notifications/read-all', payload || {}).then((r) => r.data),
  remove: (id) => client.delete(`/notifications/${id}`).then((r) => r.data),
};

export default notificationsApi;
